/* ==========================================================================
   VITAL VIAL - Header: mega menu, mobile drawer, cart count
   Keyboard + pointer accessible. Hover opens on desktop, click always works.
   ========================================================================== */
(function () {
  'use strict';

  var OPEN_DELAY = 90;
  var CLOSE_DELAY = 220;

  function initHeader(scope) {
    var header = (scope || document).querySelector('[data-vv-header]');
    if (!header || header.dataset.vvBound === '1') return;
    header.dataset.vvBound = '1';

    var overlay = header.querySelector('[data-vv-nav-overlay]');
    var items = header.querySelectorAll('[data-vv-nav-item]');
    var openTimer, closeTimer, current = null;

    function panelOf(item) { return item.querySelector('.vv-mega, .vv-dropdown'); }

    function open(item) {
      if (current && current !== item) close(current);
      clearTimeout(closeTimer);
      item.classList.add('is-open');
      var btn = item.querySelector('.vv-nav__link');
      if (btn && btn.tagName === 'BUTTON') btn.setAttribute('aria-expanded', 'true');
      if (overlay && panelOf(item) && panelOf(item).classList.contains('vv-mega')) {
        overlay.hidden = false;
        requestAnimationFrame(function () { overlay.classList.add('is-open'); });
      }
      current = item;
    }

    function close(item) {
      if (!item) return;
      item.classList.remove('is-open');
      var btn = item.querySelector('.vv-nav__link');
      if (btn && btn.tagName === 'BUTTON') btn.setAttribute('aria-expanded', 'false');
      if (current === item) current = null;
      if (!current && overlay) {
        overlay.classList.remove('is-open');
        setTimeout(function () { if (!current) overlay.hidden = true; }, 320);
      }
    }

    function closeAll() { items.forEach(close); }

    items.forEach(function (item) {
      var trigger = item.querySelector('.vv-nav__link');

      item.addEventListener('mouseenter', function () {
        if (window.matchMedia('(hover: none)').matches) return;
        clearTimeout(closeTimer);
        openTimer = setTimeout(function () { open(item); }, OPEN_DELAY);
      });

      item.addEventListener('mouseleave', function () {
        if (window.matchMedia('(hover: none)').matches) return;
        clearTimeout(openTimer);
        closeTimer = setTimeout(function () { close(item); }, CLOSE_DELAY);
      });

      if (trigger && trigger.tagName === 'BUTTON') {
        trigger.addEventListener('click', function (e) {
          e.preventDefault();
          item.classList.contains('is-open') ? close(item) : open(item);
        });
      }

      // Close when focus leaves the whole item (keyboard users)
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) close(item);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });

    if (overlay) overlay.addEventListener('click', closeAll);

    document.addEventListener('click', function (e) {
      if (!header.contains(e.target)) closeAll();
    });
  }

  /* ---------- Mobile drawer --------------------------------------------- */
  function initDrawer() {
    var drawer = document.querySelector('[data-vv-drawer]');
    if (!drawer || drawer.dataset.vvBound === '1') return;
    drawer.dataset.vvBound = '1';

    var releaseFocus = null;
    var opener = null;

    function openDrawer() {
      opener = document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('vv-no-scroll');
      var panel = drawer.querySelector('.vv-drawer__panel');
      if (window.vvTrapFocus) releaseFocus = window.vvTrapFocus(panel, closeDrawer);
      document.querySelectorAll('[data-vv-drawer-open]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'true');
      });
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('vv-no-scroll');
      if (releaseFocus) { releaseFocus(); releaseFocus = null; }
      document.querySelectorAll('[data-vv-drawer-open]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
      });
      if (opener && opener.focus) opener.focus();
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-vv-drawer-open]')) { e.preventDefault(); openDrawer(); }
      else if (e.target.closest('[data-vv-drawer-close]')) { e.preventDefault(); closeDrawer(); }
    });

    // Accordion inside the drawer
    drawer.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-vv-drawer-toggle]');
      if (!toggle) return;
      var item = toggle.closest('[data-vv-drawer-item]');
      var panel = item.querySelector('[data-vv-drawer-panel]');
      if (!panel) return;
      var isOpen = item.hasAttribute('data-open');

      if (isOpen) {
        panel.style.height = panel.scrollHeight + 'px';
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { panel.style.height = '0px'; });
        });
        panel.addEventListener('transitionend', function h() {
          panel.hidden = true; panel.removeEventListener('transitionend', h);
        });
        item.removeAttribute('data-open');
        toggle.setAttribute('aria-expanded', 'false');
      } else {
        panel.hidden = false;
        panel.style.height = panel.scrollHeight + 'px';
        item.setAttribute('data-open', '');
        toggle.setAttribute('aria-expanded', 'true');
        panel.addEventListener('transitionend', function h() {
          panel.style.height = 'auto'; panel.removeEventListener('transitionend', h);
        });
      }
    });
  }

  /* ---------- Announcement bar ------------------------------------------ */
  function initAnnounce() {
    document.querySelectorAll('[data-vv-announce]').forEach(function (bar) {
      if (bar.dataset.vvBound === '1') return;
      bar.dataset.vvBound = '1';

      var close = bar.querySelector('.vv-announce__close');
      var key = 'vv-announce-dismissed';
      if (close) {
        try { if (sessionStorage.getItem(key) === bar.dataset.vvAnnounce) bar.hidden = true; } catch (e) {}
        close.addEventListener('click', function () {
          bar.hidden = true;
          try { sessionStorage.setItem(key, bar.dataset.vvAnnounce); } catch (e) {}
        });
      }

      if (bar.getAttribute('data-mode') !== 'rotate') return;
      var slides = bar.querySelectorAll('.vv-announce__item');
      if (slides.length < 2) { if (slides[0]) slides[0].classList.add('is-active'); return; }
      var i = 0, speed = parseInt(bar.dataset.vvSpeed, 10) || 4000;
      slides[0].classList.add('is-active');
      setInterval(function () {
        slides[i].classList.remove('is-active');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-active');
      }, speed);
    });
  }

  /* ---------- Live cart count ------------------------------------------- */
  function refreshCartCount() {
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-vv-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.setAttribute('data-count', cart.item_count);
        });
      })
      .catch(function () {});
  }
  if (window.vvBus) window.vvBus.on('cart:updated', refreshCartCount);
  document.addEventListener('cart:refresh', refreshCartCount);

  function boot() { initHeader(); initDrawer(); initAnnounce(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    var t = e.target;
    if (t.querySelector('[data-vv-header]')) { t.querySelector('[data-vv-header]').dataset.vvBound = ''; initHeader(t); }
    initDrawer(); initAnnounce();
  });
})();
